import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { AxiosPromise } from '../../utils/axios.promise';
import { CommonConfig } from '../../configs/config.common';
import * as moment from 'moment';

@Component
export default class LPCommunityMarketTrend extends Vue {
    public title: string = 'LPCommunityMarketTrend';
    public config = new CommonConfig();

    @Prop({ default: () => [] })
    public data: any;

    public stats: any = null;

    public years = [
        new Date().getFullYear(),
        (new Date().getFullYear() - 1),
    ];

    @Prop({
        default: () => {
            return {
                avgPrice: [],
                medPrice: [],
                sales: [],
                doms: [],
                slrs: [],
            };
        }
    })
    public statsAws: any;

    @Prop({
        default: () => {
            return {
                propertyNew: '',
                community: '',
                city: '',
                sales: 0,
                medPrice: 0,
                avgDom: 0,
            };
        }
    })
    public community: any;

    @Watch('data', { immediate: true, deep: true })
    public async onDataInput(val: any, oldVal: any) {
        const date = new Date();
        if (T_T.simpleDetect(val) && val.length > 0) {
            const city = val[0].city;
            const propertyNew = val[0].propertyNew;
            const community = val[0].community;
            this.community.propertyNew = propertyNew;
            this.community.city = city;
            this.community.community = community;
            const apiHost = this.config.amazonCommunityHost;
            const body = {
                city: city,
                community: community,
                propertyType: propertyNew,
            };
            try {
                let fetched = await AxiosPromise.postJson(`${apiHost}/phaseone`, body);
                if (fetched.status === 200) {
                    if (fetched.data.code === 200) {
                        fetched = fetched.data;
                        const avgPricesThisYear: any[] = T_T.simpleDetect(fetched.data.avg_price_this_year) ? fetched.data.avg_price_this_year : [];
                        if (avgPricesThisYear.length > 0) {
                            const avgPriceThisYear = avgPricesThisYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / avgPricesThisYear.length;
                            this.statsAws.avgPrice.push(avgPriceThisYear);
                        }
                        const avgPricesLastYear: any[] = T_T.simpleDetect(fetched.data.avg_price_last_year) ? fetched.data.avg_price_last_year : [];
                        if (avgPricesLastYear.length > 0) {
                            const avgPriceLastYear = avgPricesLastYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / avgPricesLastYear.length;
                            this.statsAws.avgPrice.push(avgPriceLastYear);
                        }
                        const domsThisYear: any[] = T_T.simpleDetect(fetched.data.avg_dom_this_year) ? fetched.data.avg_dom_this_year : [];
                        if (domsThisYear.length > 0) {
                            const domThisYear = domsThisYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / domsThisYear.length;
                            this.statsAws.doms.push(Math.round(domThisYear));
                            this.community.avgDom = Math.round(domThisYear);
                        }
                        const domsLastYear: any[] = T_T.simpleDetect(fetched.data.avg_dom_last_year) ? fetched.data.avg_dom_last_year : [];
                        if (domsLastYear.length > 0) {
                            const domLastYear = domsLastYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / domsLastYear.length;
                            this.statsAws.doms.push(Math.round(domLastYear));
                        }
                        const slrsThisYear: any[] = T_T.simpleDetect(fetched.data.avg_slr_this_year) ? fetched.data.avg_slr_this_year : [];
                        if (slrsThisYear.length > 0) {
                            const slrThisYear = slrsThisYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / slrsThisYear.length;
                            this.statsAws.slrs.push(Math.round(slrThisYear * 100) / 100);
                        }
                        const slrsLastYear: any[] = T_T.simpleDetect(fetched.data.avg_slr_last_year) ? fetched.data.avg_slr_last_year : [];
                        if (slrsLastYear.length > 0) {
                            const slrLastYear = slrsLastYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b) / slrsLastYear.length;
                            this.statsAws.slrs.push(Math.round(slrLastYear * 100) / 100);
                        }
                        const salesThisYear: any[] = T_T.simpleDetect(fetched.data.sales_this_year) ? fetched.data.sales_this_year : [];
                        if (salesThisYear.length > 0) {
                            const salesThisYearTotal = salesThisYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b);
                            this.statsAws.sales.push(salesThisYearTotal);
                            this.community.sales = salesThisYearTotal;
                        }
                        const salesLastYear: any[] = T_T.simpleDetect(fetched.data.sales_last_year) ? fetched.data.sales_last_year : [];
                        if (salesLastYear.length > 0) {
                            const salesLastYearTotal = salesLastYear
                                .map((v: any) => v.value)
                                .reduce((a: any, b: any) => a + b);
                            this.statsAws.sales.push(salesLastYearTotal);
                        }
                        const medPricesThisYear: any[] = T_T.simpleDetect(fetched.data.med_price_this_year) ? fetched.data.med_price_this_year : [];
                        if (medPricesThisYear.length > 0) {
                            const medPriceThisYear = medPricesThisYear[0].value;
                            this.statsAws.medPrice.push(medPriceThisYear);
                            this.community.medPrice = medPriceThisYear;
                        }
                        const medPricesLastYear: any[] = T_T.simpleDetect(fetched.data.med_price_last_year) ? fetched.data.med_price_last_year : [];
                        if (medPricesLastYear.length > 0) {
                            const medPriceLastYear = medPricesLastYear[0].value;
                            this.statsAws.medPrice.push(medPriceLastYear);
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    @Prop({ default: 3 })
    public page: any;

    public getDate() {
        return moment(new Date()).format(this.config.dateFormat);
    }

    public getBarLength(a: number, b: number) {
        const max = this.getMax(a, b);
        return [
            `${Math.round(160 * a / max)}pt`,
            `${Math.round(160 * b / max)}pt`,
        ];
    }

    public randomMax(v: number) {
        return v * (this.getRandomInt(2, 5) / 10 + 1);
    }

    public getRandomInt(min: any, max: any) {
        return min + Math.floor(Math.random() * (max - min + 1));
    }

    public getMax(a: any, b: any) {
        return a - b > 0 ? a : b;
    }
}
